import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import TierPermissions from '~/Classes/tierPermissions'
import axios from '~/data/http/axios'

export default function useTierAllowed(feature, limit) {
    const account = useSelector((state) => state.accountMaster)
    const [requiredTier, setRequiredTier] = useState(null)
    const [tierAllowed, setTierAllowed] = useState(TierPermissions(feature, account).allowed)

    useEffect(() => {
        let q = `?feature=${feature}`
        if (limit) {
            q += `&limit=${limit}`
        }
        axios
            .get('/accountMaster/plan/requiredTier' + q)
            .then((res) => {
                setRequiredTier(res.data)
            })
            .catch((err) => {
                console.error('Failed to fetch requiredTier:', err)
            })
    }, [feature])

    useEffect(() => {
        setTierAllowed(TierPermissions(feature, account).allowed)
    }, [account])

    return { tierAllowed, requiredTier }
}
